import moment from 'moment';

export const DEFAULT_TIMEZONE = 'America/New_York';

export const convertUTCtoTimeZone = function (date: any, timeZone = getTimeZone()) {
    // return date ? moment.utc(date).tz(timeZone).format('DD MMM YYYY, hh:mm A') : null;
};

export const formatDateTime = function (date: any) {
    return date ? moment.utc(date).format('DD MMM YYYY') : null;
};

export const formatDateTimeDisplay = function (date: any) {
    return date ? moment.utc(date).format('DD MMM YYYY hh:mm A') : null;
};

export const formatMonth = function (date: any) {
    return date ? moment.utc(date).format('MMM YYYY') : null;
};

export const formatMonthByNumber = function (date: any) {
    return date ? moment.utc(date).format('MM-YYYY') : null;
};

export const formatYear = function (date: any) {
    return date ? moment.utc(date + 1).format('YYYY') : null;
};

export const formateTime = function (time: any) {
    const [hours, minutes] = time.split(':');
    return `${hours}h ${minutes}m`;
};

export const formatDateMonth = function (date: any) {
    let dateArr: any = [];
    !window.cn(date) && date.map((item: any) => dateArr.push(moment.utc(item).format('DD MMM ')));

    return dateArr;
};

export const getTimeZone = function () {
    let timezone;
    var pageUrl = window.location.href;
    if (pageUrl.indexOf('/admin/') > 0) {
        timezone = DEFAULT_TIMEZONE;
    } else {
        if (localStorage.getItem('timezone') && localStorage.getItem('timezone') !== null) {
            timezone = localStorage.getItem('timezone');
        }
    }
    return timezone;
};

export const createMarkup = (converdata: any) => {
    return { __html: converdata };
};

export const dateFormatTemplate = (rowData: any, rowIndex: any) => {
    return <>{rowData.created_at === rowData[rowIndex.field] ? moment.utc(rowData.created_at).format('MMM DD, YYYY') : rowData[rowIndex.field]}</>;
};

export const imageTemplate = (rowData: any, rowIndex: any) => {
    return (
        <>
            {!window.cn(rowData.photo) ? (
                <div className="main-img-box">
                    <img src={rowData.photo} className="img-fluid" alt="main-img" />
                </div>
            ) : (
                <div className="main-img-box">
                    <img src="/assets/images/no-image.jpeg" width="50" height="40" alt="no-data-img" />
                </div>
            )}
        </>
    );
};
